// Board scale singleton.
//
// The "Large Board" setting renders the whole board at 2x by scaling the
// world-anchored <group> in Scene.tsx. HEX_SIZE and axialToWorld must NOT
// change — the WASM sim bakes world coordinates into snapshot tile
// transforms (projection.rs is axialToWorld's twin), so the scale lives
// strictly on the render side, and every consumer that turns a tile
// coordinate into a world-space camera/audit position multiplies it through
// here (Scene camera framing, __aodCamera, minimap clicks, flight targets).
//
// A module singleton rather than React state because some consumers are
// closures created once (Canvas onCreated, flight callbacks) that must read
// the live value.

export const BOARD_SCALE = { current: 1 };

export const DOUBLE_SCALE = 2;

export function getBoardScale(): number {
  return BOARD_SCALE.current;
}

export function setBoardScale(s: number): void {
  BOARD_SCALE.current = s;
}

/** Scale a world-space point (from tile coords) into rendered space. */
export function scalePoint(p: readonly [number, number, number]): [number, number, number] {
  const s = BOARD_SCALE.current;
  return [p[0] * s, p[1] * s, p[2] * s];
}
